import { Module } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import ShippingState from '@vue-storefront/core/modules/checkout/types/ShippingState'
import config from 'config'

export const shippingModule: Module<ShippingState, RootState> = {
  namespaced: true,
  state: {
    methods: config.shipping.methods,
    shippingDetailsState: {
      shipToMyAddress: false,
      showNewAddressForm: false,
      saveToAddressBook: false
    }
  },
  mutations: {
    addMethod (state, shippingMethods) {
      state.methods.push(shippingMethods)
    },
    replaceMethods (state, shippingMethods) {
      state.methods = shippingMethods
    },
    updateShippingDetailsState (state, shippingDetailsState) {
      state.shippingDetailsState = shippingDetailsState
    }
  },
  actions: {
    addMethod ({commit}, shippingMethod) {
      commit('addMethod', shippingMethod)
    },
    replaceMethods ({commit}, shippingMethods) {
      commit('replaceMethods', shippingMethods)
    },
    updateShippingDetailsState ({commit}, shippingDetailsState) {
      commit('updateShippingDetailsState', shippingDetailsState);
    }
  },
  getters: {
    shippingMethods (state) {
      if (state.methods.length == 1) {
        return state.methods
      } else {
        let shippingPrices = []

        state.methods.forEach((value, index) => {
          shippingPrices[index] = value.amount
        })

        let minValue = Math.min(...shippingPrices)
        let minValueIdx = shippingPrices.indexOf(minValue)

        return state.methods.splice(minValueIdx, 1)
      }
    },
    getShippingDetailsState (state) {
      return state.shippingDetailsState;
    }
  }
}
